// Register programme G1 (owner decision, 5 Oct 2026): the current ownership interest is the
// one record of who holds each unit; lease parties and leaseholder roles reconcile to it.
export const leaseholderIssues = ['no_current_ownership', 'overlapping_ownership', 'role_not_on_ownership', 'role_without_unit', 'owner_without_role', 'lease_party_not_on_ownership'];
export const leaseholderIssueActions = {
    no_current_ownership: [],
    overlapping_ownership: [],
    role_not_on_ownership: ['add-to-ownership', 'end-role'],
    role_without_unit: ['end-role'],
    owner_without_role: ['add-role'],
    lease_party_not_on_ownership: ['add-to-ownership', 'end-lease-party'],
};
export const leaseholderIssueLabels = {
    no_current_ownership: 'No current owner recorded',
    overlapping_ownership: 'More than one current owner record',
    role_not_on_ownership: 'Has a leaseholder role but is not on the ownership record',
    role_without_unit: 'Leaseholder role with no unit',
    owner_without_role: 'On the ownership record but has no leaseholder role',
    lease_party_not_on_ownership: 'Named on the lease but not on the ownership record',
};
export const leaseholderActionLabels = {
    'add-to-ownership': 'Add to ownership record',
    'end-role': 'End leaseholder role',
    'add-role': 'Add leaseholder role',
    'end-lease-party': 'Mark as former lease party',
};
//# sourceMappingURL=leaseholder-reconciliation.js.map